import * as Joi from "joi";
import i18n from "src/i18n";

const validationSchemas = () =>
  Joi.object({
    name: Joi.string().min(3)
      .required()
      .trim()
      .empty("")
      .label(i18n.t("Product name"))
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
        "string.min": `{#label} ${i18n.t("validationErrors.minLength", { min: 3 })}`,
      }),
    sku: Joi.string()
      .optional()
      .trim()
      .empty("")
      .label(i18n.t("SKU"))
      .messages({
        "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
      }),
    price: Joi.number()
  .required()
  .greater(0)
  .label(i18n.t("Price"))
  .messages({
    "any.required": `{#label} ${i18n.t("validationErrors.isRequired")}`,
    "number.base": `{#label} ${i18n.t("validationErrors.mustBeNumber")}`,
    "number.greater": `{#label} ${i18n.t("validationErrors.isPositive")}`,
  })
  });

export default validationSchemas;
